module.exports = __webpack_public_path__ + "static/media/parking-light-gray.d4ed6b16.svg";